<div class="container-fluid page" *ngIf="!edit && !importExcelBtn">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp; Market Rate Updates
    <div class="export_csv" style="margin-bottom: 5px !important">
      <div class="add_button_text">
        <button
          class="add_button_new"
          (click)="formPage()"
          mat-raised-button
          color="primary"
        >
          Add New Market Rate</button
        >&nbsp;

        <button
          class="add_button_new"
          (click)="dominantMarket()"
          mat-raised-button
          color="primary"
        >
          Dominant Market</button
        >&nbsp;

        <button
          class="clear_button_export"
          (click)="importPage()"
          mat-raised-button
          color="primary"
        >
          Import</button
        >&nbsp;
        <button
          class="clear_button_export"
          (click)="openDialogexport()"
          mat-raised-button
          color="primary"
        >
          Export
        </button>
      </div>
    </div>
  </div>

  <div class="page__content shadow p-3">
    <div>
      <br />
      <div class="row" style="margin-top: -40px">
        <div class="col-3 topData">
          <p>Last Updated Rate</p>
          <p style="font-size: 2rem">
            {{
              avgCount.previousdayRate == null ? 0 : avgCount.previousdayRate
            }}
          </p>
        </div>
        <div class="col-3 topData">
          <p>Today's Rate</p>
          <p style="font-size: 2rem">
            {{ avgCount.todayRate == null ? 0 : avgCount.todayRate }}
          </p>
        </div>
        <div class="col-3 topData">
          <p>Rate Difference</p>
          <p style="font-size: 2rem">
            {{ avgCount.rateDifference == null ? 0 : avgCount.rateDifference }}
          </p>
        </div>
      </div>

      <mat-card>
        <div class="example-header" *ngIf="filtershow">
          <mat-form-field
            class="full-width-field"
            style="width: 50% !important"
          >
            <input
              matInput
              [(ngModel)]="searchData"
              (change)="changeFn($event)"
              placeholder="Search"
            /> </mat-form-field
          >&nbsp;
          <button
            type="submit"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr />
          <mat-form-field>
            <mat-select [(ngModel)]="marketName" placeholder="Market Name">
              <mat-option
                *ngFor="let opt of marketdatalist"
                (click)="getMarketId(opt.marketID)"
                [value]="opt.marketName"
              >
                {{ opt.marketName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field>
            <mat-select placeholder="Crop" [(ngModel)]="cropName">
              <mat-option
                *ngFor="let opt of cropDataList"
                (click)="getcropId(opt.cropId)"
                [value]="opt.cropId"
              >
                {{ opt.cropName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field>
            <mat-select [(ngModel)]="productName" placeholder="Product">
              <mat-option
                *ngFor="let opt of productdatalist"
                (click)="getproductId(opt)"
                [value]="opt.productType"
              >
                {{ opt.productType }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field>
            <mat-select
              [(ngModel)]="subProductName"
              placeholder="Sub product type"
            >
              <mat-option
                *ngFor="let opt of subProductDataList"
                (click)="getSubProductListData(opt.subProductTypeCode)"
                [value]="opt.subProductTypeName"
              >
                {{ opt.subProductTypeName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;

          <mat-form-field>
            <input
              matInput
              type="text"
              name="daterange"
              placeholder="Date Range"
              [min]="minDate"
              autocomplete="off"
              [max]="maxDate"
              [locale]="{ applyLabel: 'ok', format: 'DD-MM-YYYY' }"
              [alwaysShowCalendars]="true"
              ngxDaterangepickerMd
              [(ngModel)]="sharedate"
              [showCustomRangeLabel]="true"
              [ranges]="ranges"
              (change)="onDateRangeChanged($event)"
            />
          </mat-form-field>

          <button
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button
            type="submit"
            style="margin-top: 12px; margin-right: 10px"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>

          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip
              *ngFor="let filter of matChipArray; let i = index"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(i, filter.tag)"
            >
              {{ filter.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.MarketPriceHistoricalData.length == 0">
              There's no record found with the given criteria, please try again
              refining your search and filters
            </p>
          </div>
        </div>
      </mat-card>
      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="dateposted">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.dateposted.split(" ")[0] }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="expectedPrice">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Rate
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.expectedPrice }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="marketName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Market
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.marketName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="cropName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Crop
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.cropName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="productTypeName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Product Type
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.productTypeName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="subproductType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Sub Product Type
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData"
              >{{ HistoricalData.subproductType }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="unit">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Unit
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData"
              >{{ HistoricalData.unitName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="updatedBy">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Updated By
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              {{ HistoricalData.createdBy }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Action
            </mat-header-cell>
            <mat-cell *matCellDef="let HistoricalData">
              <div>
                <mat-icon (click)="editPage(HistoricalData)">edit</mat-icon>
                <mat-icon
                  style="margin-left: 20px"
                  (click)="openDialog(HistoricalData)"
                  >delete</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <div>
          <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            (page)="getServerData($event)"
            [pageSizeOptions]="[10, 20, 50]"
            [pageSize]="pageSize"
            showFirstLastButtons
            aria-label=""
            class="pagination"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- *************************edit******************************************** -->
<div class="container-fluid page" *ngIf="edit">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp; Edit Market Rate Updates
  </div>

  <div class="example-header" style="height: 557px">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="marketrateform" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">
            <input
              type="hidden"
              formControlName="id"
              required
              name="id"
              value=""
            />

            <mat-form-field>
              <input matInput readonly [value]="currentD" />
            </mat-form-field>

            <mat-form-field>
              <mat-select
                formControlName="MarketId"
                placeholder="Market Name"
                required
              >
                <mat-option
                  *ngFor="let opt of marketdatalist"
                  (click)="getMarketId(opt.marketID)"
                  [value]="opt.marketName"
                >
                  {{ opt.marketName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="marketrateform.get('MarketId').hasError('required')"
              >
                Please Select Market Name.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-select
                formControlName="cropId"
                placeholder="Crop Type"
                required
              >
                <mat-option
                  *ngFor="let opt of cropDataList"
                  (click)="getcropId(opt.cropId)"
                  [value]="opt.cropName"
                >
                  {{ opt.cropName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="marketrateform.get('cropId').hasError('required')"
              >
                Please Select Crop Name.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-select
                formControlName="ProductId"
                placeholder="Product Type"
                required
              >
                <mat-option
                  *ngFor="let opt of productdatalist"
                  (click)="getproductId(opt)"
                  [value]="opt.productType"
                >
                  {{ opt.productType }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="marketrateform.get('ProductId').hasError('required')"
              >
                Please Select Product Name.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-select
                formControlName="SubProductId"
                placeholder="Sub Product Type"
                required
              >
                <mat-option
                  *ngFor="let opt of subProductDataList"
                  (click)="getsubproductId(opt.subProductTypeCode)"
                  [value]="opt.subProductTypeName"
                >
                  {{ opt.subProductTypeName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="marketrateform.get('ProductId').hasError('required')"
              >
                Please Select Sub-Product Name.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-select
                formControlName="unitID"
                placeholder="Unit Type"
                required
              >
                <mat-option
                  *ngFor="let opt of unitDataList"
                  (click)="getUnitId(opt.unitID)"
                  [value]="opt.unitName"
                >
                  {{ opt.unitName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="marketrateform.get('unitID').hasError('required')"
              >
                Please Select unit Name.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <input
                type="text"
                required
                (input)="deleteInputStream($event)"
                formControlName="Rate"
                [ngClass]="{ 'is-invalid': submitted && f.Rate.errors }"
                matInput
                placeholder="Rate (INR / KG)"
              />

              <mat-error *ngIf="marketrateform.get('Rate').hasError('max')">
                Please Enter less Than 10000000.
              </mat-error>
              <mat-error *ngIf="marketrateform.get('Rate').hasError('min')">
                Please Enter More Than 0.
              </mat-error>
            </mat-form-field>
            <div *ngIf="requirederror">Please Enter Mandatory Fields</div>

            <div class="row">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <button
                  mat-button
                  type="submit"
                  [disable]="disable"
                  style="color: white"
                  class="submitBtn"
                >
                  Post
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="container-fluid page" *ngIf="importExcelBtn" style="height: 657px">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      (click)="listPage()"
      class="arrow"
    />&nbsp;&nbsp;Import Market Rate Data
  </div>
  <div>
    <mat-card
      style="
        margin-top: -2rem;
        border-radius: 10px;
        padding: 10px 20px 10px 20px;
      "
    >
      <div class="row" style="margin-top: 14px">
        <div class="col-md-6">
          <input (change)="selectFile($event)" type="file" #inputFile />
          <button
            (click)="removeFile()"
            *ngIf="isButtonVisible"
            matTooltip="remove attachment"
            style="border: none"
            mat-stroked-button
            aria-label="remove file"
          >
            <mat-icon class="clearIcon">clear</mat-icon>
          </button>
        </div>
        <div class="col-md-6 pull-right">
          <p class="pull-right templateCls">
            <a class="link" href="/assets/market-rate-bulkimport-file.xlsx"
              >Download the template</a
            >
          </p>
        </div>
      </div>
    </mat-card>

    <div
      class="mat-elevation-z8 position-relative"
      style="margin-top: 15px"
      *ngIf="!preview"
    >
      <mat-card style="height: 480px; border-radius: 10px">
        <div class="textCls">
          <p>Please select an Excel sheet to preview it's data here.</p>
        </div>
      </mat-card>
    </div>

    <div *ngIf="preview">
      <div
        class="mat-elevation-z8 position-relative"
        id="output"
        style="margin-top: 15px"
      >
        <mat-table
          #table
          [dataSource]="dataSource1"
          matSort
          style="max-height: 400px"
        >
          <ng-container matColumnDef="Date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isDate(dataString.Date)"
            >
              <!-- <span *ngIf="isDate(dataString.Date)===''" >
              {{dataString.Date | date : 'dd/MM/yyyy' }}
              </span>
              <span *ngIf="isDate(dataString.Date)==='textRed'" >
              {{dataString.Date}}
              </span> -->{{ dataString.Date | date : "dd/MM/yyyy" }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Rate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Rate
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isValidRate(dataString.Rate)"
              >{{ dataString.Rate }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Market">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Market
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isMarket(dataString.Market)"
              >{{ dataString.Market }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Crop">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Crop
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isCrop(dataString.Crop)"
              >{{ dataString.Crop }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Product">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >Product Type
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isProductType(dataString['Product'])"
            >
              {{ dataString["Product type"] }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="subProduct">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Sub Product type
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isValidVariety(dataString)"
              >{{
                dataString[
                  "Sub Product
              type"
                ]
              }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Status
            </mat-header-cell>
            <mat-cell
              *matCellDef="let dataString"
              [ngClass]="isValid(dataString) ? '' : 'textRed'"
            >
              {{ isValid(dataString) ? "Ok" : "Incorrect" }}</mat-cell
            >
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns1"></mat-row>
        </mat-table>
      </div>
      <mat-card style="height: 70px; margin-top: 15px; border-radius: 10px">
        <div class="row">
          <div class="col-md-9 pull-right bottomCard">
            <p style="float: right; margin-top: 7px">
              Record Count : {{ length1 }}
            </p>
          </div>
          <div class="col-md-3">
            <button mat-raised-button color="primary" (click)="uploadData()">
              Upload Data</button
            >&nbsp;
            <button mat-raised-button color="primary" (click)="cancelPage()">
              Cancel
            </button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
